import { render, staticRenderFns } from "./LineChartPlaceholder.vue?vue&type=template&id=38947b9b&scoped=true&"
import script from "./LineChartPlaceholder.vue?vue&type=script&lang=js&"
export * from "./LineChartPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38947b9b",
  null
  
)

export default component.exports